
export function getBalance(dispatch) {
  const cashoutTimeout = setTimeout(() => {
    dispatch({ type: 'WEBSOCKET_SEND', payload: { event: 'balance' } });
    clearTimeout(cashoutTimeout);
  }, 1500);
}